import React, {useEffect, useState} from 'react';

const SearchJobBasicContent = (props) => {
    const [searchInput, setSearchInput] = useState({});

    const {onChange, advanceSearchInput} = props

    const onChangeSearchInputInfo = (fieldName, value) => {
        searchInput[fieldName] = value
        setSearchInput({...searchInput})

        if (onChange) {
            onChange({...searchInput})
        }
    };

    useEffect(() => {
        setSearchInput(advanceSearchInput)
    }, [advanceSearchInput])

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Thông tin cơ bản</h3>
            </div>
            <div className='card-body'>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Employer ID</label>
                    <input type='text' className='form-control'
                           value={searchInput["employer_id"] ? searchInput["employer_id"] : ''}
                           name={"employer_id"}
                           onChange={event => onChangeSearchInputInfo("employer_id", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Job ID</label>
                    <input type='text' className='form-control'
                           value={searchInput["job_id"] ? searchInput["job_id"] : ''}
                           name={"job_id"}
                           onChange={event => onChangeSearchInputInfo("job_id", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Tên Employer</label>
                    <input type='text' className='form-control'
                           value={searchInput["employer_name"] ? searchInput["employer_name"] : ''}
                           name={"employer_name"}
                           onChange={event => onChangeSearchInputInfo("employer_name", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Job Title</label>
                    <input type='text' className='form-control'
                           value={searchInput["job_title"] ? searchInput["job_title"] : ''}
                           name={"job_title"}
                           onChange={event => onChangeSearchInputInfo("job_title", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Job Title (to send)</label>
                    <input type='text' className='form-control'
                           value={searchInput["job_title_to_send"] ? searchInput["job_title_to_send"] : ''}
                           name={"job_title_to_send"}
                           onChange={event => onChangeSearchInputInfo("job_title_to_send", event.target.value)}/>
                </div>
                {/*<div className='input-group mt-3'>*/}
                {/*    <label className={'w-100'}>Job Name</label>*/}
                {/*    <input type='text' className='form-control'*/}
                {/*           value={searchInput["job_name"] ? searchInput["job_name"] : ''}*/}
                {/*           name={"job_name"}*/}
                {/*           onChange={event => onChangeSearchInputInfo("job_name", event.target.value)}/>*/}
                {/*</div>*/}
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Khoảng lương (trđ)</label>
                    <div className=' col-sm-6'>
                        <div style={{width: '100%'}}>
                            <div className="form-group">
                                <input type="number"
                                       className="form-control" name={'min_salary'}
                                       value={searchInput.min_salary}
                                       onChange={event => onChangeSearchInputInfo('min_salary', event.target.value)}
                                       placeholder="" autoComplete="off"/>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div style={{width: '100%'}}>
                            <div className="form-group">
                                <input type="number"
                                       className="form-control" name={'max_salary'}
                                       value={searchInput.max_salary}
                                       onChange={event => onChangeSearchInputInfo('max_salary', event.target.value)}
                                       placeholder="" autoComplete="off"/>
                            </div>
                        </div>
                    </div>
                </div>
                {/*<div className='input-group mt-3'>*/}
                {/*    <label className={'w-100'}>Địa điểm LV</label>*/}
                {/*    <input type='text' className='form-control'*/}
                {/*           value={searchInput["work_address"] ? searchInput["work_address"] : ''}*/}
                {/*           name={"work_address"}*/}
                {/*           onChange={event => onChangeSearchInputInfo("work_address", event.target.value)}/>*/}
                {/*</div>*/}
                {/*<div className='input-group mt-3'>*/}
                {/*    <label className={'w-100'}>Lương tối đa (trđ)</label>*/}
                {/*    <input type='number' className='form-control'*/}
                {/*           value={searchInput["max_salary"] ? searchInput["max_salary"] : ''}*/}
                {/*           name={"max_salary"}*/}
                {/*           onChange={event => onChangeSearchInputInfo("max_salary", event.target.value)}/>*/}
                {/*</div>*/}
                {/*<div className='input-group mt-3'>*/}
                {/*    <label className={'w-100'}>Lương thưởng, đãi ngộ (to send)</label>*/}
                {/*    <input type='text' className='form-control'*/}
                {/*           value={searchInput["bonus"] ? searchInput["bonus"] : ''}*/}
                {/*           name={"bonus"}*/}
                {/*           onChange={event => onChangeSearchInputInfo("bonus", event.target.value)}/>*/}
                {/*</div>*/}
                {/*<div className='input-group mt-3'>*/}
                {/*    <label className={'w-100'}>Sếp trực tiếp</label>*/}
                {/*    <input type='text' className='form-control'*/}
                {/*           value={searchInput["direct_manager_id"] ? searchInput["direct_manager_id"] : ''}*/}
                {/*           name={"direct_manager_id"}*/}
                {/*           onChange={event => onChangeSearchInputInfo("direct_manager_id", event.target.value)}/>*/}
                {/*</div>*/}
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Note</label>
                    <input type='text' className='form-control'
                           value={searchInput["note"] ? searchInput["note"] : ''}
                           name={"note"}
                           onChange={event => onChangeSearchInputInfo("note", event.target.value)}/>
                </div>

            </div>
        </div>
    )
}

export default SearchJobBasicContent;
